import { useEffect, useState } from 'react';
import SiteNav from '@/components/feature/SiteNav';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import HotSeries from './components/HotSeries';
import Categories from './components/Categories';
import LatestUpdates from './components/LatestUpdates';
import Featured from './components/Featured';
import About from './components/About';
import Faq from './components/Faq';

export default function Home() {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('全部');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handlePickCategory = (c: string) => {
    setCategory(c);
    setSearch('');
    document.querySelector('#hot')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <SiteNav onSearch={setSearch} />
      <main>
        <Hero />
        <HotSeries search={search} category={category} onCategoryChange={setCategory} />
        <Categories onPick={handlePickCategory} />
        <LatestUpdates />
        <Featured />
        <About />
        <Faq />
      </main>
      <SiteFooter />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-md transition-colors hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      )}
    </>
  );
}